import React from 'react';
import {ExtraVariation} from 'components/customer/Job/entity/Job';

const isApplianceExtraVariation = (
    variation: Pick<ExtraVariation, 'job_cabinet_appliance_id'>
): boolean => {
    return (
        variation.job_cabinet_appliance_id != null &&
        variation.job_cabinet_appliance_id > 0
    );
};

/**
 * Label for appliance-linked extras (product + detail), otherwise bare name.
 *
 * @param {object} variation Extra variation row from the API
 * @return {React.ReactNode} Combined product/detail labels, or the variation name
 */
export const getExtraVariationLabel = (
    variation: Pick<
        ExtraVariation,
        'job_cabinet_appliance_id' | 'product_label' | 'detail_label' | 'name'
    >
): React.ReactNode => {
    if (isApplianceExtraVariation(variation)) {
        if (variation.product_label && variation.detail_label) {
            return (
                <>
                    <div>{variation.product_label}</div>
                    <em>({variation.detail_label})</em>
                </>
            );
        }

        if (variation.detail_label) {
            return <em>{variation.detail_label}</em>;
        }

        if (variation.product_label) {
            return variation.product_label;
        }
    }

    return variation.name;
};
